import { Component, Inject, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { PdfViewerModule } from 'ng2-pdf-viewer';

/**
 * Modal dialog component that displays PDF documents with loading and network-error state handling.
 */
@Component({
    selector: 'app-pdf-modal',
    imports: [MatDialogContent, MatButton, MatDialogActions, PdfViewerModule, MatIcon, TranslocoDirective],
    templateUrl: './pdf-modal.component.html',
    styleUrl: './pdf-modal.component.scss',
})
export class PdfModalComponent {
    /** Whether the PDF is currently loading */
    protected loading = signal<boolean>(true);

    /** Whether there was an network-error loading the PDF */
    protected loadingError = signal<boolean>(null);

    constructor(
        public dialogRef: MatDialogRef<PdfModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { pdfUrl: string }
    ) {}

    /** Dismisses the modal dialog */
    closeModal() {
        this.dialogRef.close();
    }

    /** Handles successful PDF load by clearing loading state */
    onPdfLoaded() {
        this.loading.set(false);
    }

    /** Handles PDF load failure by setting network-error state */
    onLoadError() {
        this.loading.set(false);
        this.loadingError.set(true);
    }
}
